// extracted by mini-css-extract-plugin
export default {"modal":"UnidadServiciosModal_modal__XKoWE"};